/**
 * META-1 (PR #352): Agent Assistant API client.
 *
 * Backend: apps/api/src/modules/agent-assistant/
 */
import { privateApi } from '@/config/axios.config';

export interface ToolDefinition {
  name: string;
  description: string;
  critical: boolean;
  input_schema: any;
}

export interface ToolCallResult {
  success: boolean;
  toolName: string;
  result?: any;
  error?: string;
  requiresConfirmation?: boolean;
}

export interface PendingConfirmation {
  toolName: string;
  input: Record<string, any>;
  summary: string;
}

export interface AgentChatResult {
  message: string;
  toolCalls?: ToolCallResult[];
  pendingConfirmation?: PendingConfirmation;
  memoriesUsed: number;
  llmAuditLogId: string;
}

export interface AgentMemory {
  id: string;
  category: 'cliente' | 'propiedad' | 'agendamiento' | 'general';
  content: string;
  relatedEntityId: string | null;
  relatedEntityType: string | null;
  createdAt: string;
}

const API = '/agent-assistant';

export const agentAssistantApi = {
  async chat(payload: {
    message: string;
    conversationId?: string;
    confirmedToolCallId?: string;
    confirmedToolInput?: Record<string, any>;
  }): Promise<AgentChatResult> {
    const response = await privateApi.post<{
      success: boolean;
      data: AgentChatResult;
    }>(`${API}/chat`, payload);
    return response.data.data;
  },

  async listTools(): Promise<ToolDefinition[]> {
    const response = await privateApi.get<{
      success: boolean;
      data: ToolDefinition[];
    }>(`${API}/tools`);
    return response.data.data;
  },

  async listMemories(): Promise<AgentMemory[]> {
    const response = await privateApi.get<{
      success: boolean;
      data: AgentMemory[];
    }>(`${API}/memories`);
    return response.data.data;
  },
};
